export const notificationsList = [
  {
    title: '3rd March 2025: Phone Number Verification (PNV) for Android',
    text: 'The PNV entitlement provides mobile and web app developers with a secure, real-time and fraud-resistant alternative to SMS OTP for phone number verification. By leveraging Android APIs and ES, end-users benefit from a more streamlined experience.',
  },
  {
    title:
      '4th November 2024: Cross Platform RCS is now available for all carriers',
    text: "Cross-platform RCS allows a capable device to check if the subscriber's account is entitled for RCS and enable RCS messaging between iOS and Android devices.",
  },
  {
    title: '29th October 2024: Support for VoLTE Default-On for all carriers',
    text: 'VoLTE Default-On is now available for all carriers. The VoLTE Default-On entitlement switches VoLTE on by default for all your subscribers on VoLTE capable iOS devices promoting higher usage of your VoLTE network capabilities.',
  },
  {
    title: '31st May 2024: Support for Apple iPad',
    text: 'We have added Apple iPad to our list of available use cases. With this enhancement, wireless carriers can now support all eSIM-enabled cellular iPads. Customers can seamlessly connect their iPads to the same network as their primary devices under a single account. The new iPad transfer capability allows customers to migrate their subscriptions from one iPad to another without QR code scanning, ensuring smooth and convenient data migration when upgrading to a new model.',
  },
  {
    title: '16th April 2024: eSIM and EAP-AKA Documentaton',
    text: "We've improved our documentation on eSIM Management and EAP-AKA describing common integration scenarios in greater detail.",
  },
  {
    title: '10th April 2024: Devices Page ',
    text: 'Our devices page can now be used in your production environment to view device API logs.',
  },
  {
    title: '1st March 2024: UI Overhaul',
    text: 'Our Portal has been updated with a fresh new look!',
  },
  {
    title: '22nd February 2024: Addition of our Onboarding Guide',
    text: 'An onboarding guide has been added to provide you with a better description of our onboarding process and the touchpoints with the OEM.',
  },
  {
    title: '20th February 2024: Support for multiple SM-DP+',
    text: 'Our platform now supports carrier setups that use multiple SM-DP+. See the release eSIM API of our carrier API specification for details.',
  },
  {
    title:
      '13th February 2024: ES FQDNs for iOS and Android are now visible directly from',
    text: 'Push notification topics as well as ES FQDNs for iOS and Android are now visible directly from the implementation page in your production environment.',
  },
  {
    title:
      '9th January 2024: Improved support for default SM-DP+ configuration',
    text: 'We&apos;ve made configuring your default SM-DP+ easier by adding it to the implementation page.',
  },
  {
    title: '12th and 19th of December 2023: Documentation and FAQ improvements',
    text: 'We have added a FAQ as well as numerous documentation improvements describing the UI, UX and technical interaction with your OSS/BSS for our ES use cases.',
  },
  {
    title: '7th December 2023: Addition of Production Readiness Configuration',
    text: 'Production readiness configuration screens have been added to your production environment.',
  },
  {
    title: '1st November 2023: Billing and Reporting UI improvements',
    text: 'Our Billing and Reporting UI has been improved based on carrier feedback.',
  },
  {
    title: '4th September 2023: SIM Swap improvements',
    text: 'We have added a more extensive SIM Swap request to provide you with more information about the source and target devices.',
  },
  {
    title: '10th August 2023: Websheet branding for eSIM Transfer',
    text: 'Our portal now supports branding and sub-branding of your Websheets for eSIM Transfer. We have also added configuration options to our implementation settings for mutual TLS for our inbound API for Push notifications',
  },
  {
    title: '29th June 2023: Android support added',
    text: 'We have added Android support by implementing TS.43 for eSIM transfer, Watch and Wearables, 5G, VoWifi, VoLTE and Baseline. Use your single implementation of our OEM agnostic Carrier API Specification to offer your Android subscribers these same ES Use Cases',
  },
  {
    title: '24th April 2023: Apple Watch added',
    text: 'We have added Apple Watch support and you can now select Apple Watch as a Use Case',
  },
  {
    title: '22nd March 2023: Carrier API Updates',
    bulletpointsText: 'We have updated our API specification to include:',
    bulletpoints: [
      {
        point:
          'Support for asynchronous provisioning and asynchronous SIM Swap (with Push notifications)',
      },
      {
        point:
          'Support for using multiple brands (sub-branding) for your WebSheets',
      },
    ],
    text: 'Our portal will be updated shortly to allow you to configure these options on the Implementation page',
  },
  {
    title: '27th February 2023: GA release',
    text: 'GA release with Baseline ES and eSIM Transfer',
  },
];
